<script>
  import {mapActions, mapGetters} from 'vuex';
  import {show403, show404} from 'router/utils/errorPages';
  import ApiNotFoundError from 'utils/api/errors/ApiNotFoundError';
  import ApiPermissionDeniedError from 'utils/api/errors/ApiPermissionDeniedError';
  import {isCurrentAppSeller} from 'utils/appTypeState';

  // triggers fetch on props change and after component creation
  export default {
    name: 'PropsDependentPage',
    data () {
      return {
        handle404: false,
        handle403: false,
        doNotFetchData: false,

        componentDataIsLoading: false
      };
    },
    computed: {
      ...mapGetters(isCurrentAppSeller() ? 'sellerCommon' : 'common', ['appLoading']),
      isLoading: {
        get () {
          /*
           * appLoading is global value (from store) and componentDataIsLoading is local
           * this is done to prevent triggering watchers on `isLoading` for child components
           * when navigation happens (but component hasn't been unmounted yet)
           * and global isLoading value is set to false
           */
          return this.appLoading && this.componentDataIsLoading;
        },
        set (val) {
          this.componentDataIsLoading = val;
          return this.setAppLoading(val);
        }
      }
    },
    watch: {
      $props: {
        async handler () {
          if (this.doNotFetchData) {
            return;
          }
          await this.fetch();
        },
        deep: true
      }
    },
    async mounted () {
      this.setAppLoading(true);

      if (!this.doNotFetchData) {
        await this.fetchData();
      }
    },
    methods: {
      ...mapActions(isCurrentAppSeller() ? 'sellerCommon' : 'common', {setAppLoading: 'SET_APP_LOADING'}),

      async fetch () {
        try {
          await this.fetchData();
        } catch (e) {
          if (e instanceof ApiNotFoundError && this.handle404) {
            return show404();
          } else if (e instanceof ApiPermissionDeniedError && this.handle403) {
            return show403();
          }

          throw e;
        }

        // reset loading state in any case
        this.isLoading = false;
      },

      // do some staff before fetching all data
      async beforeDataFetch () {
        return null;
      },

      // returns promises list that can be fetched in async way
      fetchDataAsync () {
        return [];
      },

      // returns single promise
      async fetchDataSync () {
        return null;
      },

      // callback after all data is fetched (may be promise)
      afterDataFetch () {},
      async fetchData () {
        this.isLoading = true;

        await this.beforeDataFetch();

        await Promise.all([...this.fetchDataAsync(), this.fetchDataSync()]);

        await this.afterDataFetch();

        this.isLoading = false;
      }
    }
  };
</script>
